import useOffers from './useOffers';

export default useOffers;
